import script from "./ChPractice.vue?vue&type=script&setup=true&lang=js"
export * from "./ChPractice.vue?vue&type=script&setup=true&lang=js"

import "./ChPractice.vue?vue&type=style&index=0&id=564bb207&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564bb207"]])

export default __exports__